import Vue from "vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
RepositoryFactory.get("messages");

export type messageType = {
	messages: [];
};

export const MessageMixin = Vue.extend({
	name: "MessageMixin",
	data: () => ({
		messages: [],
	}),
	methods: {
		async submitMessage(inputText: string, nickName: string) {
			if (inputText !== "") {
				await this.$store.dispatch("common/setMessage", { inputText, nickName });
				await (this.messages = JSON.parse(
					JSON.stringify(this.$store.getters["common/messages"])
				));
			} else {
				console.log("メッセージが未入力");
			}
		},
	},
	async beforeMount(): Promise<void> {
		await this.$store.dispatch("common/fetchMessage");
		await (this.messages = JSON.parse(
			JSON.stringify(this.$store.getters["common/messages"])
		));
	},
});
